import React from 'react';
import { Link } from 'react-router-dom'
import Header from '../components/header/Header';
import LatestCollection from '../components/layouts/explore/LatestCollection'
import dataCollections from '../assets/fake-data/dataCollections'
import PopularCollection from '../components/layouts/explore/PopularCollection';
import dataPopularCollection from '../assets/fake-data/dataPopularCollection';
import { Newsletters } from '../components/layouts/Newsletters';
import Footer from '../components/footer/Footer';
import { useSearchParams, useLocation } from "react-router-dom";
import { useState } from 'react';
import { parseNFTokenID } from 'xrpl';
import axios from 'axios';
import icon from '../assets/images/icon/bg-page-title2.png'
import icon2 from '../assets/images/icon/bg-page-title.png'


const Explore01 = () => {

    const [ids, setIds] = useState([]);
    const [dataToDisplay, setDataToDisplay] = useState([]);
    const [nfts, setNfts] = useState([]);

    const { search } = useLocation();
    const match = search.match(/address=(.*)/);
    const match2 = search.match(/richlist=(.*)/);
    const richlistBool = match2?.[1];
    const type = match?.[1];

    const ENDPOINT_FOR_VER = 'https://api.xrpscan.com/api/v1'

    async function getNftImage(id) {
    try {
	        // let onTheDex = `https://marketplace-api.onxrp.com/api/metadata/${id}`;
            let onTheDex = `https://marketplace-api.onxrp.com/api/nfts/${id}?include=nftActivities,offers,owner`
	        let imageUrl = `https://marketplace-api.onxrp.com/api/image/${id}`;
	        let response = await fetch(onTheDex);
	        let data = await response.json();
            console.log(data)
            let pfp = data.data.owner.picture_url;
	        let name = data.data.name;
            let fprice = data.data.fixed_price;
            let highestBid = data.data.highest_bid_price;
            //select the highest bid price
            let price = fprice > highestBid ? fprice : highestBid;
	        return { image: imageUrl, name: name, price: price , market: 'onXRP', pfp: pfp}
    } catch (error) {
        console.log('error', error)
    }}


    async function getNftImages2(id) {
        try {
            // console.log('id', id)
            // let url = `https://nft-viewer-api.vercel.app/api/getnftsData?id=${id}`;
            let url = `https://nft-viewer-api.vercel.app/api/getnftsData?id=${id}`
            let response = await axios.get(url)
            // console.log('response', response)
            let data2 = parseNFTokenID(id);
            let data = await response.data;
            //convert data from string to json
            data = data.msg
            // console.log('data', data)
            let name = data.metadata.name;
            let taxon = data2.Taxon;
            let oldIss = data.collection_id;
            let res;
            let avatarUrl = ''
            let imageUrl = `https://storage.googleapis.com/nft-assets-public/data/${oldIss}/${taxon}`;
            avatarUrl = ''
            try {
                let sale = ''
                sale = data.sale.quote_amount;
                let quote_cur = ''
                quote_cur = data.sale.quote_currency;
                let priceString = sale + ' ' + quote_cur;
                return { image: imageUrl, name: name, price: priceString ,market: 'sologenic' , pfp: avatarUrl};
            } catch (error) {
                return { image: imageUrl, name: name, price: '0 XRP' ,market: 'sologenic' , pfp: avatarUrl};
            }

            // return { image: imageUrl, name: name, price: priceString, taxon: taxon };
        } catch (error) {
            console.log('error', error)
        }
}
    //above method but make requests in parallel
    async function getNftImage1(ids){
        const promises = ids.map(id => getNftImage(id));
        const results = await Promise.all(promises);
        return results;
    }

    async function getNftImage2(ids) {
        const promises = ids.map(id => getNftImages2(id));
        const results = await Promise.all(promises);
        return results;
    }

    async function verifyAddress(address) {
        fetch(`${ENDPOINT_FOR_VER}/account/${address}`)
            // .then(response => console.log(response))
            //check if the response code is not 200
            .then(response => {
                if (!response.ok) {
                    alert('Invalid address');
                    window.location.href = `/explore-01`;

                }
                return response;
            })
            .then(response => response.json())
            .then(async data => {
                // console.log(data);
                if (data.error) {
                    console.log('error');
                } else {
                    console.log('success');
                    let url = 'https://nft-viewer-api.vercel.app/api/getAllNfts'
                    url = url + '?address=' + type;
                    let response = await axios.get(url);
                    console.log('response', response)
                    let nftIdIssuerDict = response.data.msg;
                    //{'00080000067DD79B9C75DC200180971A35489CFEF464207F0000099B00000000': 'rbKoFeFtQr2cRMK2jRwhgTa1US9KU6v4L',
                    //'00081702153AA708D64FF2E79DFE9D2D8E27845F9AB4E3C892B201A700002C0C': 'rpAETGuhJW5ZYfg3PdsCTELv4ho147AoE9',
                    //'000817024EC543906E622D5E959A014444D88DCB64EEDC43EAEC423100000B9D': 'r3BWpaFk3rtWhhs2Q5FwFqLVdTPnfVUJLr'}
                    //the structure of the dict is nftId: issuer
                    // rGNuFE4e2c5NwEp2HnuiJqaSVdaNYRQ7PV issuer belongs to nftIds, rMQw4pe2eXvs6b5hKLNM2MCgVqHEHwXBkJ issuer belongs to nftIds2

                    let nftIds = [];
                    let nftIds2 = [];
                    for (let key in nftIdIssuerDict) {
                        if (nftIdIssuerDict[key] === 'rGNuFE4e2c5NwEp2HnuiJqaSVdaNYRQ7PV') {
                            nftIds.push(key);
                        }
                        if (nftIdIssuerDict[key] === 'rMQw4pe2eXvs6b5hKLNM2MCgVqHEHwXBkJ') {
                            nftIds2.push(key);
                        }
                    }
                        
                        setIds(nftIds);
                        setNfts(nftIds.length + nftIds2.length);
                        
                        let oxpData = await getOXPnfts(nftIds);
                        let soloData = await getSologenicnfts(nftIds2);
                        // console.log('soloData', soloData);
                        let allData = oxpData.concat(soloData);
                        console.log('allData', allData);
                        setDataToDisplay(allData);
                }
            })

        async function getOXPnfts(nftIds) {
            let nftImages = [];
            let names = [];
            let prices = [];
            let pfp = ''
            let nftImagesAndNames = await getNftImage1(nftIds);
            if (nftImagesAndNames.length > 0){
                pfp = nftImagesAndNames[0].pfp;
            }
            for (let i = 0; i < nftImagesAndNames.length; i++) {
                nftImages.push(nftImagesAndNames[i].image);
                names.push(nftImagesAndNames[i].name);
                prices.push(nftImagesAndNames[i].price);
            }
            let data = [];
            for (let i = 0; i < nftIds.length; i++) {
                data.push({
                    img: nftImages[i],
                    title: names[i],
                    owner: type,
                    price: `${prices[i]} XRP`,
                    market: 'onXRP',
                    url: `https://nft.onxrp.com/nft/${nftIds[i]}`,
                    pfp: pfp
                });
            }
            return data;
        }
        async function getSologenicnfts(nftIds) {
            let nftImages = [];
            let names = [];
            let prices = [];
            let pfp = null
            let nftImagesAndNames = await getNftImage2(nftIds);
            for (let i = 0; i < nftImagesAndNames.length; i++) {
                nftImages.push(nftImagesAndNames[i].image);
                names.push(nftImagesAndNames[i].name);
                prices.push(nftImagesAndNames[i].price);
            }
            if (nftImagesAndNames.length > 0 )
            {
                pfp = nftImagesAndNames[0].pfp;
            }
            let data = [];
            
            for (let i = 0; i < nftIds.length; i++) {
                if (pfp == '' || pfp == undefined){
                    if (nftImagesAndNames[i].name.includes('3D')){

                    }
                    else{
                    pfp = nftImages[i];
                    }
                }
                data.push({
                    img: nftImages[i],
                    title: names[i],
                    owner: type,
                    price: prices[i],
                    market: 'sologenic',
                    url: `https://sologenic.org/nft/${nftIds[i]}`
                });
            }
            // console.log(data);
            return data;
        }
    }

    useState(() => {
        if (type) {
            verifyAddress(type);
        }
    }, [type, richlistBool]);

    console.log(type);

  return <div className='explore'>
    <Header />
    {/* <img src={icon} className='banner' /> */}
    {/* only show the above icon/banner if the page is viewer, i.e if type parameter is there */}
    {!richlistBool
        ? <img src={icon} className='banner' />
        : <img src={icon2} className='banner' />
    }

    {/* <section className="fl-page-title"> */}
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        {/* <div className="page-title" style={{textAlign: 'center', marginTop: '10px', marginLeft: 'auto', marginRight: 'auto'}}>
                            <a href="/" className="logo">
                                <img src="https://astronaughties.space/wp-content/uploads/2022/05/Logo-1.png" style={{width: '100px', height: '100px'}}></img>
                                {isMobile ? <h3 className='display-3'>Astronaughties</h3> : <h1 className='display-3'>Astronaughties</h1>}
                            </a>
                        </div> */}
                    </div>
                </div>
            </div>
          <div className="container">
          </div>
      {/* </section> */}
      <PopularCollection data={dataToDisplay} visible={nfts} />
  </div>;
};

export default Explore01;
